import cn from './styles.module.css';

const FormRow = ({
  children,
  title,
}: {
  title: string;
  children: React.JSX.Element;
}) => (
  <div className={cn.createAccountFormRow}>
    <div className={cn.createAccountFormRowTitle}>{title}</div>
    {children}
  </div>
);

export default FormRow;
